export const authRole = {
  admin: ['user', 'admin'],
  user: ['user'],
};

export const RoutePermittedRole = {
  admin: 'admin',
  user: 'user',
};

export const ThemeStyle = {
  MODERN: 'modern',
  STANDARD: 'standard',
};

export const ThemeMode = {
  LIGHT: 'light',
  SEMI_DARK: 'semi-dark',
  DARK: 'dark',
};

export const LayoutType = {
  FULL_WIDTH: 'full-width',
  BOXED: 'boxed',
  FRAMED: 'framed',
};

export const MenuStyle = {
  DEFAULT: 'default',
  STANDARD: 'standard',
  ROUNDED: 'rounded',
  ROUNDED_REVERSE: 'rounded-reverse',
  CURVED_MENU: 'curved-menu',
};

export const NavStyle = {
  DEFAULT: 'default',
  MINI: 'mini',
  MINI_SIDEBAR_TOGGLE: 'mini-sidebar-toggle',
  STANDARD: 'standard',
  HEADER_USER: 'user-header',
  HEADER_USER_MINI: 'user-mini-header',
  DRAWER: 'drawer',
  BIT_BUCKET: 'bit-bucket',
  H_DEFAULT: 'h-default',
  HOR_HEADER_FIXED: 'hor-header-fixed',
  HOR_DARK_LAYOUT: 'hor-dark-layout',
};
export const FooterType = {
  FIXED: 'fixed',
  FLUID: 'fluid',
};
export const ThemeDirection = {
  RTL: 'rtl',
  LTR: 'ltr',
};

export const UploadType = {
  PICTURE: 'PICTURE',
  ICON: 'ICON',
  FILE: 'FILE',
  SMALLPICTURE: 'SMALLPICTURE',
};

export const SubOrdersStatus = {
  Placed: 1,
  Preparing: 2,
  ReadyForPickup: 3,
  InRoute: 4,
  Delivered: 5,
  DeliveryFailed: 6,
  Rejected: 7,
  PaymentFailed: 8,
};

export type SubOrderStatusValue =
  (typeof SubOrdersStatus)[keyof typeof SubOrdersStatus];

export const SUB_ORDER_STATUS_DISPLAY_ORDER: SubOrderStatusValue[] = [
  SubOrdersStatus.Placed,
  SubOrdersStatus.Preparing,
  SubOrdersStatus.ReadyForPickup,
  SubOrdersStatus.InRoute,
  SubOrdersStatus.Delivered,
  SubOrdersStatus.DeliveryFailed,
  SubOrdersStatus.Rejected,
];

export const SUB_ORDER_TERMINAL_STATUSES: SubOrderStatusValue[] = [
  SubOrdersStatus.Delivered,
  SubOrdersStatus.DeliveryFailed,
  SubOrdersStatus.Rejected,
  SubOrdersStatus.PaymentFailed,
];

export const SUB_ORDER_STATUS_BY_NAME: Record<string, SubOrderStatusValue> = {
  Placed: SubOrdersStatus.Placed,
  Preparing: SubOrdersStatus.Preparing,
  ReadyForPickup: SubOrdersStatus.ReadyForPickup,
  InRoute: SubOrdersStatus.InRoute,
  Delivered: SubOrdersStatus.Delivered,
  DeliveryFailed: SubOrdersStatus.DeliveryFailed,
  Rejected: SubOrdersStatus.Rejected,
  PaymentFailed: SubOrdersStatus.PaymentFailed,
};

export const ProductAttributeType = {
  Color: 'Color',
  Size: 'Size',
};

export const OrderReturnStatus = {
  Pending: 1,
  WarehouseRecived: 2,
  QualityCheck: 3,
  Approved: 4,
  Rejected: 5,
};

export const BannerStatus = {
  Pending: 1,
  Approved: 2,
  Rejected: 3,
};

export const BannerTypes = {
  SubCategory: 'SubCategory',
  Url: 'Url',
  Products: 'Products',
};
export enum shopStatusEnum {
  Pending = 0,
  Approved = 1,
  Rejected = 2,
}

export const ModalMangeType = {
  ManagePoints: 1,
  ManageWallet: 2,
};

export const offerType = {
  ProductOffering: 1,
  PriceOffering: 2,
};

export const modalOfferType = {
  create: 'create',
  mange: 'mange',
};

export const amountType = {
  Fixed: 'Fixed',
  Percent: 'Percent',
  FreeDelivery: 'Free Delivery',
};

export const targetType = {
  Products: 'Products',
  Categories: 'Categories',
  Shops: 'Shops',
  All: 'All',
};

export const policyMode = {
  pdf: 1,
  Text: 0,
  Html: 2,
};

export const ProductTabs = {
  MappingCategory: 'mappingCategory',
  General: 'general',
  SizeGuide: 'sizeGuide',
  MiniImageAndSubColor: 'miniImageAndSubColor',
  PictureAndColor: 'pictureAndColor',
  ProductAttributes: 'productAttributes',
  SpecificationAttributes: 'specificationAttributes',
  LinkedProduct: 'linkedProduct',
  ProductReviews: 'productReviews',
  ProductRejectionReasons: 'productRejectionReasons',
};

export enum ManageShopKeys {
  General = 'general',
  WareHoseTab = 'wareHoseTab',
  Overview = 'overview',
  Preview = 'preview',
}

export enum ProductStatus {
  Pending = 0,
  Approved = 1,
  Rejected = 2,
}

export enum PolicyShowingMode {
  PdfMode = 1,
  FileMode = 0,
  HtmlMode = 2,
}

export enum GiftCardStatus {
  Pending = 1,
  Approved = 2,
  Rejected = 3,
}

export enum TransactionType {
  Order = 1,
  Other = 2,
  Debit = 3,
}

export const GiftCardStatusNames = {
  Pending: 'Pending',
  Approved: 'Approved',
  Rejected: 'Rejected',
};
export enum PolicyType {
  Shop = 0,
  Public = 1,
}

export enum PolicyKey {
  None = 0,
  PrivacyPolicy = 1,
  TermsAndConditions = 2,
}

export enum pickupDateType {
  ReadyTime = 0,
  LastPickupTime = 1,
  ClosingTime = 2,
}

export const PushCampaignType = {
  Product: 'promo.product',
  Shop: 'promo.shop',
  Category: 'promo.category',
  Coupon: 'promo.coupon',
  Offer: 'promo.offer',
  General: 'promo.general',
};

export const PushCampaignStatus = {
  Draft: 'Draft',
  Scheduled: 'Scheduled',
  Sending: 'Sending',
  Sent: 'Sent',
  Cancelled: 'Cancelled',
};

export const PUSH_CAMPAIGN_NOTIFICATION_PREVIEW_TRUNCATION = 60;

export const PUSH_CAMPAIGN_ENTITY_BY_TYPE: Record<string, boolean> = {
  Product: true,
  Shop: true,
  Category: true,
  Coupon: true,
  Offer: true,
  General: false,
};

export enum DaysOfWeek {
  Sunday = 0,
  Monday = 1,
  Tuesday = 2,
  Wednesday = 3,
  Thursday = 4,
  Friday = 5,
  Saturday = 6,
}

export const OrderReasonType = {
  DeliveryFailed: 1,
  Rejected: 2,
} as const;

export type OrderReasonTypeValue =
  (typeof OrderReasonType)[keyof typeof OrderReasonType];

export const OrderReasonResponsibleParty = {
  Customer: 1,
  Courier: 2,
  Shop: 3,
  Other: 4,
} as const;

export type OrderReasonResponsiblePartyValue =
  (typeof OrderReasonResponsibleParty)[keyof typeof OrderReasonResponsibleParty];

export const RESPONSIBLE_PARTY_GROUP_ORDER: OrderReasonResponsiblePartyValue[] = [
  OrderReasonResponsibleParty.Customer,
  OrderReasonResponsibleParty.Courier,
  OrderReasonResponsibleParty.Shop,
  OrderReasonResponsibleParty.Other,
];

export const RESPONSIBLE_PARTY_BY_NAME: Record<
  string,
  OrderReasonResponsiblePartyValue
> = {
  Customer: OrderReasonResponsibleParty.Customer,
  Courier: OrderReasonResponsibleParty.Courier,
  Shop: OrderReasonResponsibleParty.Shop,
  Other: OrderReasonResponsibleParty.Other,
};
